/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Thin_Robin_DiveInputs */

const en_full_thin_robin_dive = /** @type {(inputs: Full_Thin_Robin_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail or employee number is required for identification`)
};

const de_full_thin_robin_dive = /** @type {(inputs: Full_Thin_Robin_DiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail oder Personalnummer wird für die Identifikation benötigt.`)
};

/**
* | output |
* | --- |
* | "E-mail or employee number is required for identification" |
*
* @param {Full_Thin_Robin_DiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_thin_robin_dive = /** @type {((inputs?: Full_Thin_Robin_DiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Thin_Robin_DiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_thin_robin_dive(inputs)
	return de_full_thin_robin_dive(inputs)
});